module.exports = __webpack_public_path__ + "img/UP.777112f1.png";